import { useSelector } from 'react-redux';
import PageLayout from '../subcomponents/PageLayout';
import TimetableTab from './TimetableTab';

export default function TimetableManagementPage() {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    return (
        <PageLayout
            title={resourceFinal[appLanguage].words.MANAGEMENT_TIMETABLE}
            content={
                <>
                    <TimetableTab />
                </>
            }
            bottomBar
            fullScreen
        />
    );
}

